export const WORK_ORDER = 'workOrders'

export const workOrder = {
  en: {
    translation: {
      [WORK_ORDER]: {
        assignedLineItems: 'Assigned Items',
        remainingItems: 'Remaining Items',
        downloadPDF: 'Download PDF',
        markCompleted: 'Mark All Completed',
        productName: 'Product Name',
        sku: 'SKU',
        location: 'Location',
        quantity: 'Qty',
        price: 'Price',
        unitPrice: 'Unit Price',
        images: 'Images',
        invoicedDate: 'Invoiced Date',
        addNewItem: 'Add Item',
        addRow: 'Add Row',
        details: 'Description',
        status: 'Status',
        complete: 'Complete',
        verification: 'Verification',
        showPrice: 'Show Price to Vendor',
        sendNotification: 'Send Notification',
        markAllVerified: 'Mark All Verified',
        markAllCompleted: 'Mark All Completed',
        remainingList: 'Items List',
        total: 'Total',
        profit: 'Profit',
        clientAmount: 'Client Amount',
        vendorAmount: 'Vendor Amount',
        actions: 'Actions',
        upload: 'Upload',
        select: 'Select',
        deleteRows: 'Delete Row(s)',
        emptyTableText: 'No Items Assigned',
        emptyWorkOrders: 'No workorders created.',
        unassignLineItems: 'Unassign Items',
        clientApprovedAmountInfo: 'Client Approved Amount is required to enable add items.',
        amount: 'Amount',
        itemsLoading: 'Items Loading...',
        uploadWO: 'Upload WO',
        requiredLineItemsToast:
          'Please fill required fields in Assigned Line Items. Description, Qty & Price are mandatory for each item.',
        rejectedInvoiceInfo:
          'Invoice and Lien Waiver have been declined. Please update Lien Waiver and regenerate Invoice.',
        companyName: 'Company Name',
        vendorType: 'Vendor Type',
        email: 'Email',
        phone: 'Phone',
        woIssued: 'WO Issued',
        lwSubmitted: 'LW Submitted',
        completionVariance: 'Completion Variance',
        claimantSignature: 'Claimant Signature',
        dateOfSignature: 'Date Of Signature',

        // New Work Order

        clientStart: 'Client Start',
        clientEnd: 'Client End',
        profitPercentage: 'Profit Percentage',
        finalSowAmount: 'Final SOW Amount',
        type: 'Type',
        clientApprovedAmount: 'Client Approved Amount',
        vendorWorkOrderAmount: 'Vendor WO Amount',
        expectedStartDate: 'Expected Start Date',
        expectedCompletionDate: 'Expected Completion Date',
        save: 'Save',
        cancel: 'Cancel',
      },
    },
  },
  es: {
    translation: {
      [WORK_ORDER]: {
        assignedLineItems: 'Elementos asignados',
        remainingItems: 'Artículos restantes',
        downloadPDF: 'Descargar como PDF',
        markCompleted: 'Marcar todo completado',
        productName: 'Nombre del producto',
        sku: 'SKU',
        addRow: 'Añadir fila',
        location: 'Ubicación',
        quantity: 'Cantidad',
        price: 'Precio',
        unitPrice: 'Precio unitario',
        images: 'Imágenes',
        addNewItem: 'Agregar ítem nuevo',
        details: 'Descripción',
        status: 'Estado',
        complete: 'Completo',
        verification: 'Verificación',
        showPrice: 'Mostrar precio al vendedor',
        sendNotification: 'Enviar notificación',
        markAllVerified: 'Marcar todo verificado',
        markAllCompleted: 'Marcar todo como completado',
        remainingList: 'Lista de artículos',
        total: 'Total',
        profit: 'Lucro',
        vendorAmount: 'Importe del proveedor',
        actions: 'Comportamiento',
        upload: 'Subir',
        select: 'Seleccione',
        unassignLineItems: 'Desasignar elementos',
        deleteRows: 'Eliminar fila(s)',
        emptyTableText: 'No hay elementos asignados',
        emptyWorkOrders: 'No se crearon órdenes de trabajo',
        clientAmount: 'Importe del cliente',
        clientApprovedAmountInfo: 'Se requiere una cantidad aprobada por el cliente para agregar artículos.',
        amount: 'Monto',
        itemsLoading: 'Cargando artículos...',
        uploadWO: 'Subir WO',
        requiredLineItemsToast:
          'Complete los campos obligatorios en Elementos de línea asignados. La descripción, la cantidad y el precio son obligatorios para cada artículo.',
        rejectedInvoiceInfo:
          'Se han rechazado la factura y la exención de gravamen. Actualice la exención de gravamen y regenere la factura.',
        companyName: 'Nombre de empresa',
        vendorType: 'Tipo de proveedor',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        woIssued: 'OT emitido',
        lwSubmitted: 'LW Enviado',
        completionVariance: 'Variación de finalización',
        claimantSignature: 'Firma del reclamante',
        dateOfSignature: 'Fecha de la firma',

        // New Work Order

        clientStart: 'Inicio del cliente',
        clientEnd: 'Extremo del cliente',
        profitPercentage: 'Porcentaje de beneficio',
        finalSowAmount: 'Importe de la SOW final',
        type: 'Escribe',
        clientApprovedAmount: 'Monto aprobado por el cliente',
        vendorWorkOrderAmount: 'Importe de la orden de trabajo del proveedor',
        expectedStartDate: 'fecha de inicio esperada',
        expectedCompletionDate: 'Fecha de finalización prevista',
        save: 'Salvar',
        cancel: 'Cancelar',
      },
    },
  },
}
